import {
    isVenueSelected,
    VenueAnalysisSelection,
    VenueSelected,
} from 'widgets/venueAnalysis/store/component/VenueAnalysisSelection';
import {
    VenueAnalysisData,
    VenueAnalysisVenueData,
} from 'widgets/venueAnalysis/venueAnalysisAggregatedData';
import { styleConstants } from 'widgets/venueAnalysis/grid/variables.module.constants';
import { VenueAnalysisVenueDisplayData } from 'widgets/venueAnalysis/grid/gridData';
import { TrapezoidPath } from 'utils/d3fc/trapezoid';

interface SankeyItem {
    key: string;
    topWidth: number;
    bottomWidth: number;
}

export function getVenueToLiquiditySankeyData(
    width: number,
    data: VenueAnalysisData,
    selection?: VenueAnalysisSelection
): TrapezoidPath[] {
    const percent = getVenuePercent(data, selection);
    if (!percent) {
        return [];
    }

    const coordinates = getVenueToLiquidityItems(width, percent, data);
    return getVenueToLiquidityPaths(coordinates);
}

export function getVenueTypeToVenueSankeyData(
    width: number,
    data: VenueAnalysisVenueDisplayData,
    selection: VenueSelected,
    className: string
): TrapezoidPath[] {
    const percent = getVenue(data.venues!, selection.venueName)?.percent;
    if (!percent) {
        return [];
    }

    const bottomWidth =
        ((width - styleConstants.singleTypePadding) * percent) / 100;

    return [
        {
            key: className,
            points: [
                [0, 0],
                [width, 0],
                [bottomWidth, 30],
                [0, 30],
            ],
        },
    ];
}

function getVenuePercent(
    data: VenueAnalysisData,
    selection?: VenueAnalysisSelection
) {
    if (!isVenueSelected(selection)) {
        return undefined;
    }
    const venueType = data.orderVenue?.venueTypes.find(
        (v) => v.name === selection.venueTypeName
    );
    if (!venueType) {
        return undefined;
    }
    return getVenue(venueType.venues, selection.venueName)?.percent;
}

function getVenue(venues: VenueAnalysisVenueData[], venueName: string) {
    return venues.find((v) => v.name === venueName);
}

function getVenueToLiquidityItems(
    width: number,
    percent: number,
    data: VenueAnalysisData
): SankeyItem[] {
    if (!percent) {
        return [];
    }
    if (!data.orderLiquidity) {
        return [];
    }

    const topWidth =
        ((width - styleConstants.singleTypePadding) * percent) / 100;

    return data.orderLiquidity.map((l) => ({
        key: l.liquidity.className,
        topWidth: (topWidth * l.percent) / 100,
        bottomWidth: (width * l.percent) / 100 - 1,
    }));
}

function getVenueToLiquidityPaths(items: SankeyItem[]): TrapezoidPath[] {
    const paths: TrapezoidPath[] = [];
    let topX = 0;
    let bottomX = 0;
    for (const i of items) {
        const path: TrapezoidPath = {
            key: i.key,
            points: [
                [topX, 0],
                [i.topWidth + topX, 0],
                [i.bottomWidth + bottomX, 50],
                [bottomX, 50],
            ],
        };
        topX = topX + i.topWidth;
        bottomX = bottomX + i.bottomWidth;
        paths.push(path);
    }
    return paths;
}
